module.exports = __webpack_public_path__ + "img/drag-indicator.svg";